import _pluralize from 'pluralize';
const pluralize = (word, count, inclusive) => {
  return _pluralize(word, count, inclusive);
};

/**
 * @deprecated Use the pluralize specific function from the pluralize package instead.
 */
export default pluralize;
export { pluralize };